// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hbe4iAVAHRAs8hwbc8eT {
  display: flex;
  background: transparent;
  border: none;
  cursor: pointer;
}
.fTde4HbXtVmjj3lF2VU_ img,
.fTde4HbXtVmjj3lF2VU_ svg {
  filter: var(--filter-active-icon);
}
/* Disabled state when settings modal is open */
.Hbe4iAVAHRAs8hwbc8eT:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.zK_2B3oDvtvh19lYybF2 {
  display: flex;
  justify-content: flex-end;
  background: transparent;
  border: none;
  cursor: pointer;
  gap: 3px;
}
.zK_2B3oDvtvh19lYybF2:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.jCa8ATDPZl6lGpVwJN0o {
  filter: grayscale(100%);
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/features/navigation/components/StatusBar/actions/Actions.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,iCAAiC;AACnC;AACA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,QAAQ;AACV;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".searchButtonContainer {\n  display: flex;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n.searchButtonActive img,\n.searchButtonActive svg {\n  filter: var(--filter-active-icon);\n}\n/* Disabled state when settings modal is open */\n.searchButtonContainer:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.settingsButtonContainer {\n  display: flex;\n  justify-content: flex-end;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  gap: 3px;\n}\n.settingsButtonContainer:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.disabledIcon {\n  filter: grayscale(100%);\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchButtonContainer": `Hbe4iAVAHRAs8hwbc8eT`,
	"searchButtonActive": `fTde4HbXtVmjj3lF2VU_`,
	"settingsButtonContainer": `zK_2B3oDvtvh19lYybF2`,
	"disabledIcon": `jCa8ATDPZl6lGpVwJN0o`
};
export default ___CSS_LOADER_EXPORT___;
